<template>
  <w-dialog @close="close" :show="MemberShow" customClass="staffs-dialog">
    <div class="staffs-dialog-addbox" v-if="state===1">
      <div class="title" :title="porjectInf.name">
        {{porjectInf.name}}
        <a class="close w-icon-guanbi" @click="close(100113062)"></a>
      </div>
      <div class="staffs-dialog-cnt">
        <w-row>
          <w-col :span="8">
            <w-input size="small" v-model="keyword" placeholder="请输入姓名、广联云账号" />
          </w-col>
          <w-col :span="8">
            <w-button type="minor" class="mar10" @click="search()">搜索</w-button>
          </w-col>
        </w-row>
        <w-row class="tabbox" :gutter="20">
          <w-col :span="14">
            <div class="grid-content bg-purple tabborder">
              <div class="tabtitle">待选人名单</div>
              <div class="tabcnt">
                <table cellpadding="0" cellspacing="0">
                  <tr v-for="(item, i) in userList" :key="i">
                    <td class="name">
                      <div v-html="item.sname"></div>
                    </td>
                    <td v-html="item.semail"></td>
                    <td width="70">
                      <w-button type="minor" v-if="!item.isAdd" @click="addUser(item)">添加</w-button>
                      <w-button type="minor" :disabled="item.isAdd" v-else>已添加</w-button>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </w-col>
          <w-col :span="10">
            <div class="grid-content bg-purple tabborder">
              <div class="tabtitle">已选人名单</div>
              <div class="tabcnt">
                <div class="error-blue" v-if="error!==''">
                  {{error}}
                </div>
                <table v-else cellpadding="0" cellspacing="0">
                  <template v-for="(item,k) in userListData">
                    <tr v-if="item.isAdd" :key="k">
                      <td class="name name2">
                        <div>{{item.name}}</div>
                      </td>
                      <td>{{item.email}}</td>
                      <td width="70">
                        <w-button type="minor" @click="delUser(item)">移除</w-button>
                      </td>
                    </tr>
                  </template>

                </table>
              </div>
            </div>
          </w-col>
        </w-row>
      </div>
      <div class="foot">
        <w-button type="primary" @click="confirm">确定</w-button>
        <w-button type="minor" @click="close(100113061)">取消</w-button>
      </div>
    </div>
    <div class="staffs-dialog-result staffs-dialog-ok" v-else-if="state===2">
      <a class="close w-icon-guanbi" @click="close()"></a>
      <em class="circle-color">
        <i class="color-wancheng1 w-icon-wancheng1">
        </i>
      </em>
      <p>
        分享成功
      </p>
    </div>
    <div class="staffs-dialog-result staffs-dialog-fail" v-else>
      <a class="close w-icon-guanbi" @click="close()"></a>
      <em class="circle-color">
        <i class="color-shibai w-icon-shibai">
        </i>
      </em>
      <p>
        分享失败，请稍后再试
      </p>
    </div>
  </w-dialog>
</template>

<script>
import SpaceService from '@/assets/service/space'
import { getCookie } from '@/assets/utils/CommonUtil'
// import { baseURL, backendUrl } from '@/assets/js/config';
// let token = getCookie('ZJYTOKEN');
export default {
  data () {
    return {
      state: 1,
      show: true,
      keyword: '',
      userList: [],
      userListData: [],
      enterpriseName: '',
      workspaceId: getCookie('personalWorkspaceIdValue'),
      user: {},
      error: ''
    }
  },
  props: {
    MemberShow: Boolean,
    porjectInf: Object
  },
  methods: {
    initSelList () {
      console.log('请求用户列表。。。')
    },
    confirm () {
      let chooseList = []
      this.userListData.map(item => {
        if (item.isAdd) {
          chooseList.push({'gldUserId': item.id, 'account': item.name})
        }
      })

      if (chooseList.length === 0) {
        this.error = '请添加分享人！'
        return
      }
      this.sendShareData(chooseList)
      // this.$emit("cancel");
    },
    close (logCode) {
      logCode && this.sentLog(logCode)
      this.$emit('cancel')
      this.userList = []
      this.userListData = []
    },
    // 创建请求
    sendShareData (data){
      const { suffix, fileId, path, length } = this.porjectInf
      let params = {
        workspaceId: this.workspaceId,
        fileId,
        filePath: path,
        receiverList: data
      }
      SpaceService.sendShareMessages(params).then(res => {
        if (+res.code === 200) {
          this.sentLog(100113060, {files: [{status: 1, suffix, fileId, length}], length, status: 1})
          this.state = 2
        } else {
          this.sentLog(100113060, {files: [{status: 0, suffix, fileId, length}], length, status: 0, code: res.code})
          this.state = 3
        }
      }).catch(() => {
        this.sentLog(100113060, {files: [{status: 0, suffix, fileId, length}], length, status: 0})
        this.state = 3
      })
    },
    search (flag) {
      let userlist = [...this.userListData]
      if (this.keyword === '') {
        this.userList = userlist
        return
      }
      userlist = userlist
        .filter(item => {
          if (
            item.name &&
            item.name.toUpperCase().indexOf(this.keyword.toUpperCase()) > -1
          ) {
            return true
          }
          if (
            item.email &&
            item.email.toUpperCase().indexOf(this.keyword.toUpperCase()) > -1
          ) {
            return true
          }
          return false
        })
        .map(item => {
          let name = item.name
          let email = item.email
          let regfirst = /[0-9a-zA-Z]/
          if (name) {
            if (regfirst.test(this.keyword[0])) {
              name = name.replace(
                new RegExp(this.keyword, 'g'),
                `<span class="red">${this.keyword}</span>`
              )
            } else {
              name = name.replace(
                new RegExp('\\' + this.keyword, 'g'),
                `<span class="red">${this.keyword}</span>`
              )
            }
          }
          if (email) {
            if (regfirst.test(this.keyword[0])) {
              email = email.replace(
                new RegExp(this.keyword, 'g'),
                `<span  class="red">${this.keyword}</span>`
              )
            } else {
              email = email.replace(
                new RegExp('\\' + this.keyword, 'g'),
                `<span  class="red">${this.keyword}</span>`
              )
            }
          }
          return {
            ...item,
            semail: email,
            sname: name
          }
        })
      console.log(userlist)
      this.userList = userlist
    },
    addUser (item) {
      this.error = ''
      this.userListData.forEach((useritem, index) => {
        if (useritem.id === item.id) {
          useritem.isAdd = true
        }
      })
      this.userList.forEach((useritem, index) => {
        if (useritem.id === item.id) {
          useritem.isAdd = true
        }
      })
    },
    delUser (item) {
      this.userListData.forEach((useritem, index) => {
        if (useritem.id === item.id) {
          useritem.isAdd = false
        }
      })
      this.userList.forEach((useritem, index) => {
        if (useritem.id === item.id) {
          useritem.isAdd = false
        }
      })
    },
    getUserList () {
      // let param = {};
      this.userList = []
      this.userListData = []
      SpaceService.queryUserList().then(res => {
        if (+res.code === 200) {
          let userList = res.data.map(item => {
            return {
              name: item.userName,
              email: item.account,
              sname: item.userName,
              semail: item.account,
              id: item.gldUserId,
              memberId: item.gldUserId,
              isAdd: false
            }
          })
          this.userList = userList
          this.userListData = [...userList]
        } else {
          this.$message.error('获取企业员工列表失败！')
        }
      })
        .catch(e => {
          this.$message.error('获取企业员工列表失败！')
        })
    }
  },
  created () {
    // let userinfo = getCookie("ZJYUSERINFO");
    // if(userinfo){
    //   userinfo = JSON.parse(userinfo);
    //   this.user = userinfo;
    // }
    this.getUserList()
  }
}
</script>

<style  lang="less">
.staffs-dialog{
  width: auto!important;
  animation-duration: 0s!important;
}
.staffs-dialog-addbox {
  width: 880px;
  height: 520px;
  border: 1px solid #d5d5d5;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 5px;
  z-index: 999999;
  .title {
    height: 46px;
    line-height: 46px;
    color:rgba(120,120,120,1);
    font-size: 16px;
    padding-left: 20px;
    padding-right: 40px;
    border-bottom: 1px solid #eee;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .error-blue{
    width:84px;
    height:16px;
    padding: 10px;
    font-size:12px;
    color:rgba(64,158,255,1);
    line-height:16px;
  }
  .close {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    color: #cdcfd3;
    &:hover {
      color: #333;
    }
  }
  .staffs-dialog-cnt {
    padding: 20px 20px 0px;
  }
  .mar10 {
    margin-left: 10px;
  }
  .tabbox {
    margin-top: 20px;
  }
  .tabborder {
    border: 1px solid #ddd;
    border-radius: 5px;
    height: 320px;
  }
  .tabtitle {
    height: 35px;
    line-height: 35px;
    padding: 0px 10px;
    background: #f6f6f6;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .tabcnt {
    height: 275px;
    overflow: auto;

    table {
      width: 100%;
      font-size: 12px;

      td {
        height: 35px;
        border-bottom: 1px solid #ddd;

        .red {
          color: red;
        }
      }
      .name {
        padding-left: 10px;
        width: 200px;

        div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 200px;
        }
      }
      .name2 {
        padding-left: 10px;
        width: 100px;

        div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100px;
        }
      }
    }
  }
  .foot {
    text-align: right;
    padding-right: 20px;
    padding-top: 20px;
  }
  .w__button{
    width: 60px;
  }
}
.staffs-dialog-result {
  width: 400px;
  height: 238px;
  box-sizing: border-box;
  position: relative;
  background: #fff;
  border-radius: 5px;
  font-size: 24px;
  line-height: 80px;
  text-align: center;
  padding-top: 50px;
  &.staffs-dialog-fail{
    color: #e33b34;
    .circle-color{
      width: 90px;
      height: 90px;
      background: #e43931;
      display: inline-block;
      border-radius: 50%;
    }
  }
  &.staffs-dialog-ok{
    color: #4595ed;
    .circle-color{
      width: 90px;
      height: 90px;
      background: #4391fb;
      display: inline-block;
      border-radius: 50%;
      color: blue;
    }
  }
  .color-wancheng1{
    line-height: 90px;
    font-size: 100px;
    color: #4192fa;
    background: #fff;
  }
  .color-shibai{
    line-height: 90px;
    font-size: 100px;
    color: #e53932;
    background: #fff;
  }
  .close {
    position: absolute;
    right: -15px;
    top: -5px;
    transform: translateY(-50%);
    cursor: pointer;
    color: #cdcfd3;
    &:hover {
      color: #333;
    }
  }
}
</style>
